import { SVGProps } from 'react';

const Move = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v20m3-17-3-3-3 3m0 14 3 3 3-3m4-4 3-3-3-3m3 3H2m3 3-3-3 3-3"
    />
  </svg>
);
export default Move;
